import PropTypes from "prop-types";
import React from "react";
import { downloadFile } from "cxa-utils";
import { Button } from "cxa-components";
import PlanGroup from "./PlanGroup";
import { compose, withState } from "recompose";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";
import { isEmpty } from "lodash";
import PlanPerMemberForm from "./PlanPerMemberForm";
import { getFilteredPlans } from "./PlanGroup";
import { withActionHandlers } from "./PlanPerMemberEventHandlers";

const enhanceWithToggle = withState("isOpen", "toggleIsOpen", false);

const enhanceBenefit = compose(
  enhanceWithToggle,
  withActionHandlers
);

const Benefit = enhanceBenefit(
  ({
    benefit,
    currency,
    isOpen,
    toggleIsOpen,
    onPerMemberClick,
    onChangePerMemberSelection,
    intl,
  }) => {
    const enrolledSumObject = {
      // Setting Sum Assured currency to '$' since there's no current configuration available to set this.
      currency: "$",
      price: benefit.benefitSumAssuredPrice,
    };
    const enrolledBenefitObject = {
      description: intl.formatMessage({
        id: benefit.lastSelectedPlan.description,
        defaultMessage: benefit.lastSelectedPlan.description,
      }),
    };
    const hasBenefitUrl = benefit.benefitUrl && !isEmpty(benefit.benefitUrl);

    const filteredPlans = getFilteredPlans(benefit);
    const selectionMode = benefit.selectionMode;
    const planPerMemberSelection = filteredPlans.map(
      plan =>
        plan.isSelected ? (
          <PlanPerMemberForm
            key={`${benefit.benefitId}-${plan.planId}`}
            benefit={benefit}
            plan={plan}
            eligibleMembers={plan.eligibleMembers}
            currency={currency}
            onPerMemberClick={onPerMemberClick}
            onChangePerMemberSelection={onChangePerMemberSelection}
          />
        ) : (
          []
        )
    );

    return (
      <article className="card product-panel" id={benefit.benefitId}>
        <header>
          <p className="product-panel__toolbar">
            <Button type="button" tertiary onClick={() => toggleIsOpen(!isOpen)}>
              {isOpen
                ? intl.formatMessage(messages.showLessDescription)
                : intl.formatMessage(messages.showMoreDetailsDescription)}
            </Button>
            {hasBenefitUrl ? (
              <Button type="button" tertiary icon onClick={() => downloadFile(benefit.benefitUrl)}>
                <img alt="" src="/assets/images/common/ProductSummary.png" />
              </Button>
            ) : null}
          </p>
          <div className="product-panel__header">
            <h4>
              {intl.formatMessage({
                id: benefit.benefitName,
                defaultMessage: benefit.benefitName,
              })}
            </h4>
          </div>
        </header>
        <section>
          <div
            className="product-panel__short-description"
            dangerouslySetInnerHTML={{
              __html: intl.formatMessage({
                id: benefit.benefitDescription,
                defaultMessage: benefit.benefitDescription,
              }),
            }}
          />
          <div>
            {isOpen && (
              <section>
                <p className="product-panel__description">
                  {intl.formatMessage({
                    id: benefit.benefitTooltip,
                    defaultMessage: benefit.benefitTooltip,
                  })}
                </p>
              </section>
            )}
            {benefit.dependencyMessage &&
              benefit.dependencyMessage !== "" && (
                <p>
                  {intl.formatMessage({
                    id: benefit.dependencyMessage,
                    defaultMessage: benefit.dependencyMessage,
                  })}
                </p>
              )}
            {benefit.isSumAssured &&
              benefit.lastSelectedPlan.planId !== "" && (
                <p>
                  <small>
                    {intl.formatMessage(messages.lastEnrolledSumDescription, enrolledSumObject)}
                  </small>
                </p>
              )}
            {!benefit.isSumAssured &&
              benefit.lastSelectedPlan.planId !== "" && (
                <p>
                  <small>
                    {intl.formatMessage(
                      messages.lastEnrolledBenefitDescription,
                      enrolledBenefitObject
                    )}
                  </small>
                </p>
              )}
          </div>
          <PlanGroup isOpen={isOpen} benefit={benefit} currency={currency} />
          {selectionMode && selectionMode === "individual" && planPerMemberSelection}
        </section>
      </article>
    );
  }
);

Benefit.propTypes = {
  benefit: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  currency: PropTypes.string,
};

export default injectIntl(Benefit);



// WEBPACK FOOTER //
// ./components/employee/shop/BenefitPanel.js